export var bulkLoadMixin = {
  data: function data() {
    return {};
  },
  methods: {
    getSeparator: function getSeparator(row) {
      var separators = [',', ';', '|'];
      var separator = '';
      for (var _i = 0, _separators = separators; _i < _separators.length; _i++) {
        separator = _separators[_i];
        if (row.indexOf(separator) !== -1) {
          break;
        }
      }
      return separator;
    },
    getBodyJson: function getBodyJson(event) {
      var body = [];
      var results = event.target.result.split('\r\n');
      if (results.length === 1) {
        // se trata de un archivo con un solo registro
        results = event.target.result.split('\n');
      }
      var rowHeader = results.shift();
      var separator = this.getSeparator(rowHeader);
      var headers = rowHeader.split(separator);
      results.filter(function (r) {
        return r;
      }).forEach(function (result) {
        var row = result.split(separator);
        var object = {};
        for (var i = 0; i < headers.length; i++) {
          object[headers[i]] = row[i];
        }
        body.push(object);
      });
      return body;
    },
    getBody: function getBody(event) {
      var body = [];
      var results = event.target.result.split('\r\n');
      if (results.length === 1) {
        // se trata de un archivo con un solo registro
        results = event.target.result.split('\n');
      }
      var rowHeader = results.shift();
      var separator = this.getSeparator(rowHeader);
      results.filter(function (r) {
        return r;
      }).forEach(function (result) {
        body.push(result.split(separator));
      });
      return body;
    }
  }
};